import TemplateView from './TemplateView';

export default TemplateView;
